import { ResponsiveInterface } from './responsiveState';

export const setResponsiveContext = (data: ResponsiveInterface) => ({
    type: 'SET_RESPONSIVE_CONTEXT',
    payload: data,
});
